import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const SonnerToaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-center"
      duration={2800}
      visibleToasts={3}
      className="toaster group"
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "group toast border-2 border-foreground !rounded-none bg-background text-foreground shadow-2xl px-5 py-4 gap-3",
          title:
            "text-[11px] font-semibold uppercase tracking-[0.2em] text-foreground",
          description:
            "text-sm leading-relaxed text-muted-foreground mt-1",
          actionButton:
            "!rounded-none border border-foreground bg-foreground text-background uppercase tracking-[0.18em] text-[10px] font-semibold px-3 py-2 hover:bg-lexsavvy-yellow hover:text-foreground transition-colors",
          cancelButton:
            "!rounded-none border border-foreground bg-transparent text-foreground uppercase tracking-[0.18em] text-[10px] font-semibold px-3 py-2 hover:bg-foreground hover:text-background transition-colors",
          closeButton:
            "!rounded-none !border !border-foreground bg-background text-foreground hover:bg-foreground hover:text-background",
          error:
            "!border-foreground !bg-foreground !text-background",
          success:
            "!border-foreground !bg-background !text-foreground",
          warning:
            "!border-foreground !bg-lexsavvy-yellow !text-foreground",
          info:
            "!border-foreground !bg-background !text-foreground",
        },
      }}
      {...props}
    />
  )
}

export { SonnerToaster, toast }
